/* src/app/shared/weather-box/weather-box.component.scss */
.garminwidget {
  padding: 0 10px 10px 10px;
  border-radius: 20px;
}
.garminwidget2 {
  padding: 0 10px 10px 10px;
  border-radius: 20px;
  background:
    linear-gradient(
      90deg,
      rgb(255, 92, 168) 0%,
      #DE3163 100%);
}
.garminMapWidget {
  padding: 0 10px 10px 10px;
  border-radius: 20px;
}
.style1000_0 {
  background:
    url(/assets/images/stars.png) repeat top center,
    linear-gradient(
      180deg,
      rgb(2, 16, 34) 0%,
      #01264a 100%);
}
.style1003_0 {
  background:
    url(/assets/images/stars.png) repeat top center,
    linear-gradient(
      180deg,
      rgb(2, 16, 34) 0%,
      #9aacbc 100%);
}
.style1006_0 {
  background:
    linear-gradient(
      180deg,
      #333333 0%,
      #666666 100%);
}
.style1009_0 {
  background:
    linear-gradient(
      180deg,
      #3c3c3c 0%,
      #808080 100%);
}
.style1030_0 {
  background:
    linear-gradient(
      180deg,
      #4d4d4d 0%,
      #999999 100%);
}
.style1063_0 {
  background:
    linear-gradient(
      180deg,
      #595959 0%,
      #b3b3b3 100%);
}
.style1066_0 {
  background:
    linear-gradient(
      180deg,
      #666666 0%,
      #cccccc 100%);
}
.style1069_0 {
  background:
    linear-gradient(
      180deg,
      #747474 0%,
      #e6e6e6 100%);
}
.style1072_0 {
  background:
    linear-gradient(
      180deg,
      #808080 0%,
      #f2f2f2 100%);
}
.style1087_0 {
  background:
    linear-gradient(
      180deg,
      #4d4d4d 0%,
      #101010 100%);
}
.style1114_0 {
  background:
    linear-gradient(
      180deg,
      #595959 0%,
      #b3b3b3 100%);
}
.style1117_0 {
  background:
    linear-gradient(
      180deg,
      #4d4d4d 0%,
      #808080 100%);
}
.style1135_0 {
  background:
    linear-gradient(
      180deg,
      #4d4d4d 0%,
      #808080 100%);
}
.style1147_0 {
  background:
    linear-gradient(
      180deg,
      #666666 0%,
      #cccccc 100%);
}
.style1150_0 {
  background:
    linear-gradient(
      180deg,
      #595959 0%,
      #b3b3b3 100%);
}
.style1153_0 {
  background:
    linear-gradient(
      180deg,
      #595959 0%,
      #b3b3b3 100%);
}
.style1168_0 {
  background:
    linear-gradient(
      180deg,
      #666666 0%,
      #cccccc 100%);
}
.style1171_0 {
  background:
    linear-gradient(
      180deg,
      #666666 0%,
      #cccccc 100%);
}
.style1180_0 {
  background:
    linear-gradient(
      180deg,
      #595959 0%,
      #b3b3b3 100%);
}
.style1183_0 {
  background:
    linear-gradient(
      180deg,
      #595959 0%,
      #b3b3b3 100%);
}
.style1186_0 {
  background:
    linear-gradient(
      180deg,
      #595959 0%,
      #b3b3b3 100%);
}
.style1189_0 {
  background:
    linear-gradient(
      180deg,
      #595959 0%,
      #b3b3b3 100%);
}
.style1192_0 {
  background:
    linear-gradient(
      180deg,
      #595959 0%,
      #b3b3b3 100%);
}
.style1195_0 {
  background:
    linear-gradient(
      180deg,
      #595959 0%,
      #b3b3b3 100%);
}
.style1198_0 {
  background:
    linear-gradient(
      180deg,
      #666666 0%,
      #cccccc 100%);
}
.style1201_0 {
  background:
    linear-gradient(
      180deg,
      #666666 0%,
      #cccccc 100%);
}
.style1204_0 {
  background:
    linear-gradient(
      180deg,
      #747474 0%,
      #e6e6e6 100%);
}
.style1207_0 {
  background:
    linear-gradient(
      180deg,
      #747474 0%,
      #e6e6e6 100%);
}
.style1210_0 {
  background:
    linear-gradient(
      180deg,
      #666666 0%,
      #cccccc 100%);
}
.style1213_0 {
  background:
    linear-gradient(
      180deg,
      #666666 0%,
      #cccccc 100%);
}
.style1216_0 {
  background:
    linear-gradient(
      180deg,
      #666666 0%,
      #cccccc 100%);
}
.style1219_0 {
  background:
    linear-gradient(
      180deg,
      #666666 0%,
      #cccccc 100%);
}
.style1222_0 {
  background:
    linear-gradient(
      180deg,
      #666666 0%,
      #cccccc 100%);
}
.style1225_0 {
  background:
    linear-gradient(
      180deg,
      #666666 0%,
      #cccccc 100%);
}
.style1237_0 {
  background:
    linear-gradient(
      180deg,
      #747474 0%,
      #e6e6e6 100%);
}
.style1240_0 {
  background:
    linear-gradient(
      180deg,
      #595959 0%,
      #b3b3b3 100%);
}
.style1243_0 {
  background:
    linear-gradient(
      180deg,
      #595959 0%,
      #b3b3b3 100%);
}
.style1246_0 {
  background:
    linear-gradient(
      180deg,
      #595959 0%,
      #b3b3b3 100%);
}
.style1249_0 {
  background:
    linear-gradient(
      180deg,
      #747474 0%,
      #e6e6e6 100%);
}
.style1252_0 {
  background:
    linear-gradient(
      180deg,
      #747474 0%,
      #e6e6e6 100%);
}
.style1255_0 {
  background:
    linear-gradient(
      180deg,
      #666666 0%,
      #cccccc 100%);
}
.style1258_0 {
  background:
    linear-gradient(
      180deg,
      #666666 0%,
      #cccccc 100%);
}
.style1261_0 {
  background:
    linear-gradient(
      180deg,
      #747474 0%,
      #e6e6e6 100%);
}
.style1264_0 {
  background:
    linear-gradient(
      180deg,
      #747474 0%,
      #e6e6e6 100%);
}
.style1273_0 {
  background:
    linear-gradient(
      180deg,
      #4d4d4d 0%,
      #101010 100%);
}
.style1276_0 {
  background:
    linear-gradient(
      180deg,
      #4d4d4d 0%,
      #101010 100%);
}
.style1279_0 {
  background:
    linear-gradient(
      180deg,
      #333333 0%,
      #666666 100%);
}
.style1282_0 {
  background:
    linear-gradient(
      180deg,
      #333333 0%,
      #666666 100%);
}
.style1000_1 {
  background:
    linear-gradient(
      180deg,
      #6495ED 0%,
      #80c2ff 100%);
}
.style1003_1 {
  background:
    linear-gradient(
      180deg,
      #6495ED 0%,
      #9aacbc 100%);
}
.style1006_1 {
  background:
    linear-gradient(
      180deg,
      #A0AEBB 0%,
      #9aacbc 100%);
}
.style1009_1 {
  background:
    linear-gradient(
      180deg,
      #A0AEBB 0%,
      #9aacbc 100%);
}
.style1030_1 {
  background:
    linear-gradient(
      180deg,
      #51636E 0%,
      #9aacbc 100%);
}
.style1063_1 {
  background:
    linear-gradient(
      180deg,
      #6495ED 0%,
      #87CEEB 100%);
}
.style1066_1 {
  background:
    linear-gradient(
      180deg,
      #ADD8E6 0%,
      #FFFFFF 100%);
}
.style1069_1 {
  background:
    linear-gradient(
      180deg,
      #B0C4DE 0%,
      #D3D3D3 100%);
}
.style1072_1 {
  background:
    linear-gradient(
      180deg,
      #A9A9A9 0%,
      #D3D3D3 100%);
}
.style1087_1 {
  background:
    linear-gradient(
      180deg,
      #6495ED 0%,
      #ADD8E6 100%);
}
.style1114_1 {
  background:
    linear-gradient(
      180deg,
      #FFFFFF 0%,
      #D3D3D3 100%);
}
.style1117_1 {
  background:
    linear-gradient(
      180deg,
      #F5F5F5 0%,
      #D3D3D3 100%);
}
.style1135_1 {
  background:
    linear-gradient(
      180deg,
      #E0E0E0 0%,
      #FFFFFF 100%);
}
.style1147_1 {
  background:
    linear-gradient(
      180deg,
      #A9A9A9 0%,
      #D3D3D3 100%);
}
.style1150_1 {
  background:
    linear-gradient(
      180deg,
      #B0C4DE 0%,
      #D3D3D3 100%);
}
.style1153_1 {
  background:
    linear-gradient(
      180deg,
      #B0C4DE 0%,
      #D3D3D3 100%);
}
.style1168_1 {
  background:
    linear-gradient(
      180deg,
      #A9A9A9 0%,
      #D3D3D3 100%);
}
.style1171_1 {
  background:
    linear-gradient(
      180deg,
      #A9A9A9 0%,
      #D3D3D3 100%);
}
.style1180_1 {
  background:
    linear-gradient(
      180deg,
      #6495ED 0%,
      #87CEEB 100%);
}
.style1183_1 {
  background:
    linear-gradient(
      180deg,
      #A0AEBB 0%,
      #9aacbc 100%);
}
.style1186_1 {
  background:
    linear-gradient(
      180deg,
      #6495ED 0%,
      #9aacbc 100%);
}
.style1189_1 {
  background:
    linear-gradient(
      180deg,
      #9aacbc 0%,
      #87CEEB 100%);
}
.style1192_1 {
  background:
    linear-gradient(
      180deg,
      #6495ED 0%,
      #87CEEB 100%);
}
.style1195_1 {
  background:
    linear-gradient(
      180deg,
      #51636E 0%,
      #9aacbc 100%);
}
.style1198_1 {
  background:
    linear-gradient(
      180deg,
      #ADD8E6 0%,
      #FFFFFF 100%);
}
.style1201_1 {
  background:
    linear-gradient(
      180deg,
      #ADD8E6 0%,
      #FFFFFF 100%);
}
.style1204_1 {
  background:
    linear-gradient(
      180deg,
      #B0C4DE 0%,
      #D3D3D3 100%);
}
.style1207_1 {
  background:
    linear-gradient(
      180deg,
      #B0C4DE 0%,
      #D3D3D3 100%);
}
.style1210_1 {
  background:
    linear-gradient(
      180deg,
      #ADD8E6 0%,
      #FFFFFF 100%);
}
.style1213_1 {
  background:
    linear-gradient(
      180deg,
      #ADD8E6 0%,
      #FFFFFF 100%);
}
.style1216_1 {
  background:
    linear-gradient(
      180deg,
      #ADD8E6 0%,
      #FFFFFF 100%);
}
.style1219_1 {
  background:
    linear-gradient(
      180deg,
      #ADD8E6 0%,
      #FFFFFF 100%);
}
.style1222_1 {
  background:
    linear-gradient(
      180deg,
      #ADD8E6 0%,
      #FFFFFF 100%);
}
.style1225_1 {
  background:
    linear-gradient(
      180deg,
      #ADD8E6 0%,
      #FFFFFF 100%);
}
.style1237_1 {
  background:
    linear-gradient(
      180deg,
      #B0C4DE 0%,
      #D3D3D3 100%);
}
.style1240_1 {
  background:
    linear-gradient(
      180deg,
      #6495ED 0%,
      #87CEEB 100%);
}
.style1243_1 {
  background:
    linear-gradient(
      180deg,
      #6495ED 0%,
      #87CEEB 100%);
}
.style1246_1 {
  background:
    linear-gradient(
      180deg,
      #6495ED 0%,
      #87CEEB 100%);
}
.style1249_1 {
  background:
    linear-gradient(
      180deg,
      #B0C4DE 0%,
      #D3D3D3 100%);
}
.style1252_1 {
  background:
    linear-gradient(
      180deg,
      #B0C4DE 0%,
      #D3D3D3 100%);
}
.style1255_1 {
  background:
    linear-gradient(
      180deg,
      #ADD8E6 0%,
      #FFFFFF 100%);
}
.style1258_1 {
  background:
    linear-gradient(
      180deg,
      #ADD8E6 0%,
      #FFFFFF 100%);
}
.style1261_1 {
  background:
    linear-gradient(
      180deg,
      #B0C4DE 0%,
      #D3D3D3 100%);
}
.style1264_1 {
  background:
    linear-gradient(
      180deg,
      #B0C4DE 0%,
      #D3D3D3 100%);
}
.style1273_1 {
  background:
    linear-gradient(
      180deg,
      #6495ED 0%,
      #87CEEB 100%);
}
.style1276_1 {
  background:
    linear-gradient(
      180deg,
      #6495ED 0%,
      #87CEEB 100%);
}
.style1279_1 {
  background:
    linear-gradient(
      180deg,
      #87CEEB 0%,
      #ADD8E6 100%);
}
.style1282_1 {
  background:
    linear-gradient(
      180deg,
      #87CEEB 0%,
      #ADD8E6 100%);
}
.garminDistance {
  color: white;
  position: absolute;
  margin: auto;
  font-size: xxx-large;
  text-transform: uppercase;
  word-spacing: 100vw;
  max-width: 50%;
  text-align: center;
  padding-right: 9%;
  line-height: 1;
}
.topLine_1 {
  margin: 0;
  float: left;
  color: black;
  padding-top: 5px;
  max-width: 90%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.topLine_0 {
  margin: 0;
  float: left;
  color: darkgray;
  padding-top: 5px;
  max-width: 90%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.columnLeft_1 {
  color: black;
  text-align: justify;
  text-transform: uppercase;
  font-size: small;
}
.columnLeft_0 {
  color: darkgray;
  text-align: justify;
  text-transform: uppercase;
  font-size: small;
}
.columnWhite {
  padding-left: 5px;
  text-align: right;
  font-weight: bold;
  color: white;
}
.garminTable {
  z-index: 1;
}
/*# sourceMappingURL=weather-box.component.css.map */
